export default [
    {
        path: '/document/:objectType/:objectId/:entityTypeId/:entities',
        name: 'document',
        component: () => import( /* webpackChunkName: "document" */ '@/views/document/Document.vue')
    },
    {
        path: '/documentEdit/:id',
        name: 'documentEdit',
        component: () => import( /* webpackChunkName: "documentEdit" */ '@/views/document/DocumentEdit.vue')
    },
    {
        path: '/documentEmail/:objectType/:objectId/:entityTypeId/:entities',
        name: 'documentEmail',
        component: () => import( /* webpackChunkName: "documentEmail" */ '@/views/document/DocumentEmail.vue')
    },
    {
        path: '/documentEntity/:objectType/:objectId/:entityTypeId',
        name: 'documentEntity',
        component: () => import( /* webpackChunkName: "documentEntity" */ '@/views/document/DocumentEntity.vue')
    },
    {
        path: '/documentEntityType/:objectType/:objectId',
        name: 'documentEntityType',
        component: () => import( /* webpackChunkName: "documentEntityType" */ '@/views/document/DocumentEntityType.vue')
    },
    {
        path: '/documentFill/:id',
        name: 'documentFill',
        component: () => import( /* webpackChunkName: "documentFill" */ '@/views/document/Fill.vue')
    },
    {
        path: '/documentPrint/:objectType/:objectId/:entityTypeId/:entities',
        name: 'documentPrint',
        component: () => import( /* webpackChunkName: "documentPrint" */ '@/views/document/DocumentPrint.vue')
    },
    {
        path: '/documentDiary',
        name: 'documentDiary',
        component: () => import( /* webpackChunkName: "documentDiary" */ '@/views/document/DocumentDiary.vue')
    },
    {
        path: '/documents',
        name: 'documents',
        component: () => import( /* webpackChunkName: "documents" */ '@/views/document/Documents.vue')
    },
    {
        path: '/documentTemplate/:objectType/:objectId/:entityTypeId/:entities',
        name: 'documentTemplate',
        component: () => import( /* webpackChunkName: "documentTemplate" */ '@/views/document/DocumentTemplate.vue')
    },
    {
        path: '/emailTemplates',
        name: 'emailTemplates',
        component: () => import( /* webpackChunkName: "emailTemplates" */ '@/views/document/EmailTemplates.vue')
    },
    {
        path: '/emailTemplates/add',
        name: 'emailTemplateAdd',
        component: () => import( /* webpackChunkName: "emailTemplate" */ '@/views/document/EmailTemplate.vue')
    },
    {
        path: '/emailTemplates/edit/:id',
        name: 'emailTemplate',
        component: () => import( /* webpackChunkName: "emailTemplate" */ '@/views/document/EmailTemplate.vue')
    },
    {
        path: '/emailTemplateTags',
        name: 'emailTemplateTags',
        component: () => import( /* webpackChunkName: "emailTemplateTags" */ '@/views/document/EmailTemplateTags.vue')
    },
    {
        path: '/emailTemplateTags/add',
        name: 'emailTemplateTagAdd',
        component: () => import( /* webpackChunkName: "emailTemplateTag" */ '@/views/document/EmailTemplateTag.vue')
    },
    {
        path: '/emailTemplateTags/edit/:id',
        name: 'emailTemplateTag',
        component: () => import( /* webpackChunkName: "emailTemplateTag" */ '@/views/document/EmailTemplateTag.vue')
    },
    {
        path: '/footers/edit/:id',
        name: 'footer',
        component: () => import( /* webpackChunkName: "footer" */ '@/views/document/Footer.vue')
    },
    {
        path: '/footers/list',
        name: 'footers',
        component: () => import( /* webpackChunkName: "footers" */ '@/views/document/Footers.vue')
    },
    {
        path: '/revisions/:id',
        name: 'revision',
        component: () => import( /* webpackChunkName: "revision" */ '@/views/document/Revision.vue')
    },
    {
        path: '/revisions/:id/copy',
        name: 'revisionCopy',
        component: () => import( /* webpackChunkName: "revisionCopy" */ '@/views/document/RevisionCopy.vue')
    },
    {
        path: '/scanners/edit/:id',
        name: 'scanner',
        component: () => import( /* webpackChunkName: "scanner" */ '@/views/document/Scanner.vue')
    },
    {
        path: '/scanners/list',
        name: 'scanners',
        component: () => import( /* webpackChunkName: "scanners" */ '@/views/document/Scanners.vue')
    },
    {
        path: '/scanners/edit/:id/scans/edit',
        name: 'scan',
        component: () => import( /* webpackChunkName: "scan" */ '@/views/document/Scan.vue')
    },
    {
        path: '/snippets/add',
        name: 'snippetAdd',
        component: () => import( /* webpackChunkName: "snippet" */ '@/views/document/Snippet.vue')
    },
    {
        path: '/snippets/edit/:id',
        name: 'snippet',
        component: () => import( /* webpackChunkName: "snippet" */ '@/views/document/Snippet.vue')
    },
    {
        path: '/snippets/list',
        name: 'snippets',
        component: () => import( /* webpackChunkName: "snippets" */ '@/views/document/Snippets.vue')
    },
    {
        path: '/templates/add',
        name: 'templateAdd',
        component: () => import( /* webpackChunkName: "template" */ '@/views/document/Template.vue')
    },
    {
        path: '/templates/edit/:id',
        name: 'template',
        component: () => import( /* webpackChunkName: "template" */ '@/views/document/Template.vue')
    },
    {
        path: '/templates/list/:archived?',
        name: 'templates',
        component: () => import( /* webpackChunkName: "templates" */ '@/views/document/Templates.vue')
    },
    {
        path: '/uploads/common/edit/:id',
        name: 'uploadCommon',
        component: () => import( /* webpackChunkName: "uploadCommon" */ '@/views/document/UploadCommon.vue')
    },
    {
        path: '/uploads/common/add',
        name: 'uploadCommonAdd',
        component: () => import( /* webpackChunkName: "uploadCommon" */ '@/views/document/UploadCommon.vue')
    },
    {
        path: '/uploads/common/list',
        name: 'uploadsCommon',
        component: () => import( /* webpackChunkName: "uploadsCommon" */ '@/views/document/UploadsCommon.vue')
    },
    {
        path: '/uploads/add',
        name: 'upload',
        component: () => import( /* webpackChunkName: "upload" */ '@/views/document/Upload.vue')
    },
    {
        path: '/uploadEntity/:id',
        name: 'uploadEntity',
        component: () => import( /* webpackChunkName: "uploadEntity" */ '@/views/document/UploadEntity.vue')
    },
    {
        path: '/uploadFile/:id',
        name: 'uploadFile',
        component: () => import( /* webpackChunkName: "uploadFile" */ '@/views/document/UploadFile.vue')
    },
    {
        path: '/uploads/diary',
        name: 'uploads',
        component: () => import( /* webpackChunkName: "uploads" */ '@/views/document/Uploads.vue')
    },
]